export const scRoutes = {
    main: {
        route: '/swift',
        get: () => `/swift`,
    },
    getStarted: {
        main: {
            route: '/swift/get-started',
            get: () => `/swift/get-started`,
        },
        connect: {
            route: '/swift/get-started/connect',
            get: () => `/swift/get-started/connect`,
        },
        plans: {
            route: '/swift/get-started/plans',
            get: () => `/swift/get-started/plans`,
        },
        success: {
            route: '/swift/get-started/success',
            get: () => `/swift/get-started/success`,
        },
    },
    manageConnections: {
        main: {
            route: '/swift/manage-connections',
            get: () => `/swift/manage-connections`,
        },
    },
    customerPortal: {
        main: {
            route: '/swift/customer-portal',
            get: ({ return_url }) => `/swift/customer-portal?return_url=${return_url}`,
        },
    },
    posts: {
        main: {
            route: '/swift/posts',
            get: () => `/swift/posts`,
        },
    },
    workflows: {
        main: {
            route: '/swift/workflows',
            get: () => `/swift/workflows`,
        },
        business: {
            main: {
                route: '/swift/workflows/business',
                get: () => `/swift/workflows/business`,
            },
        },
        posts: {
            main: {
                route: '/swift/workflows/posts',
                get: () => `/swift/workflows/posts`,
            },
            publish: {
                route: '/swift/workflows/posts/:post_id',
                get: (post_id) => `/swift/workflows/posts/${post_id}`,
            },
        },
    },
};
//# sourceMappingURL=sc.js.map